module.exports = __webpack_public_path__ + "static/media/computerWorking.0f6cd2c3.gif";